import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './AIAgentLoader.scss'

interface AIAgentLoaderProps {
  containerClassName?: string
  className?: string
  longLoadingMessage?: string
  withChat?: boolean
}

export const AIAgentLoader: React.FC<AIAgentLoaderProps> = ({ containerClassName, className, longLoadingMessage, withChat = true }) => {
  const [showLongLoadingMessage, setShowLongLoadingMessage] = useState(false)

  useEffect(() => {
    if (longLoadingMessage) {
      const timeoutId = setTimeout(() => {
        setShowLongLoadingMessage(true)
      }, 10000)
      return () => {
        clearTimeout(timeoutId)
      }
    } else {
      setShowLongLoadingMessage(false)
    }
  }, [longLoadingMessage])

  return (
    <Container className={`d-flex pt-2 zocks-pb-2 flex-column gap-4 ai-agent-loader-container ${containerClassName}`}>
      <Row className='h-100 g-3'>
        <Col xs={12} lg={withChat ? 8 : 12}>
          <div className='h-100 zocks-p-1.25 zocks-bg-color-primary-light zocks-border-0.5'>
            <div className={`h-100 d-flex flex-column gap-2 align-items-center justify-content-center zocks-border-0.5 ${className}`}>
              <div className='ai-agent-loader' />
              <div className='paragraph-medium'>Loading…</div>
              {showLongLoadingMessage && <div className='small px-4 mt-4 text-center'>{longLoadingMessage}</div>}
            </div>
          </div>
        </Col>
        {withChat ? (
          <Col xs={12} lg={4}>
            <div className='h-100 skeleton zocks-border-1.0' />
          </Col>
        ) : null}
      </Row>
    </Container>
  )
}
